import RequestHandler from "./RequestHandler";

function LookupsAPI() {
    const baseLookupsAPI = "lookups";

    async function getRoles() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/user-roles`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getParametersWithUnit(modelId) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/models/${modelId}/parameters`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getModelStatuses() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/model-statuses`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getOrganizations() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/organizations`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getLabStorePartners() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/labstore-partners`
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function getIndustries() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/industries`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getModels(allowTranslation = true) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/models?allowTranslation=${allowTranslation}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getDeployedModels() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/deployed-models`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getMaterials() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/materials`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getSuppliers(materialId) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/suppliers/${materialId}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getTrendMaterials(filters = null) {
        try {
            const result = await RequestHandler.post(
                `${baseLookupsAPI}/trend-materials`,
                filters
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getTrendLots(filters = null) {
        try {
            const result = await RequestHandler.post(
                `${baseLookupsAPI}/trend-lots`,
                filters
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getTrendSuppliers(filters = null) {
        try {
            const result = await RequestHandler.post(
                `${baseLookupsAPI}/trend-suppliers`,
                filters
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getUsers() {
        try {
            const result = await RequestHandler.get(`${baseLookupsAPI}/users`);
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getSuperiorUsers(organizationId, emailOnly = false) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/organization-users/${organizationId}?email-only=${emailOnly}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getMaterialGroups() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/material-groups`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getAccessByModelId(modelId) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/model-access/${modelId}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getAccessByUserId(userId) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/user-models-access/${userId}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getPartners() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/partners`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getCountries(includeGlobal) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/countries${includeGlobal ? "?all=true" : ""}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getCountryByName(countryName) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/countries/name/${countryName}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function getSupportedAccessories() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/supported-accessories`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getMaterialsMeasurements(filters = null) {
        try {
            const result = await RequestHandler.post(
                `${baseLookupsAPI}/materials-measurements`,
                filters
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getMaterialsScans(filters = null) {
        try {
            const result = await RequestHandler.post(
                `${baseLookupsAPI}/materials-scans`,
                filters
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getUsedMaterialsInScans(filters) {
        try {
            const result = await RequestHandler.post(
                `${baseLookupsAPI}/scans/used-materials`,
                filters
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getUsedSuppliersInScans(materialId = "") {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/scans/used-suppliers${
                    materialId ? `?materialId=${materialId}` : ""
                }`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getUsedModelsInScans() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/scans/used-models`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getUsedLotsInScans() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/scans/used-lots`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getScanners(includeDefault = true) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/scanners?includeDefault=${includeDefault}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getBiasCorrections(modelParameterVersionId) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/bias-corrections/${modelParameterVersionId}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getScannerTypes() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/scanner-types`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getTags() {
        try {
            const result = await RequestHandler.get(`${baseLookupsAPI}/tags`);
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getCurrencies() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/currencies`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getAcceptedProducts() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/accepted-products`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getCouponAcceptedProducts() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/coupon-accepted-products`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getStoreAccesses() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/store-accesses`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getRecoveryQuestions() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/recoveryQuestions`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getInferiorUsers() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/inferior-users`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getUserOrganizations() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/user-organizations`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getSubscribedProductsDetails(organizationSubscriptionId) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/subscribed-product/${organizationSubscriptionId}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getDeployedMaterialParameters() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/deployed-material-parameters`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getSubscriptionAccess(subscriptionId) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/subscription-access/${subscriptionId}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getUnits() {
        try {
            const result = await RequestHandler.get(`${baseLookupsAPI}/units`);
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getModelParameterNamesByMaterial(materialId, mapId = false) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/parameters/${materialId}?mapId=${mapId}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }
    async function getUsedParametersForScans(materialId) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/scans/used-parameters/${materialId}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getLinkedUnitConversions(baseUnitId) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/unit-conversions/linked/${baseUnitId}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getAllowedUnitConversions(baseUnitId) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/unit-conversions/allowed/${baseUnitId}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getModelParameterUnits(modelParameterId) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/model-parameters-units/${modelParameterId}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getModelParametersByModelId(modelId) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/model-parameters/${modelId}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getClassifiers() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/classifiers`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getModelParameterProductVersionAvailableUnits(
        modelParameterProductVersionId
    ) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/product-version/available-units/${modelParameterProductVersionId}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getLots(materialId) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/lots?materialId=${materialId}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getSimplifiedModel() {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/simplified-models`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getSupervisedUsers(getUserOrganizations = false) {
        try {
            const result = await RequestHandler.get(
                `${baseLookupsAPI}/supervised-users?get-user-organizations=${getUserOrganizations}`
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    return {
        getRoles,
        getParametersWithUnit,
        getOrganizations,
        getModelStatuses,
        getIndustries,
        getLabStorePartners,
        getModels,
        getDeployedModels,
        getMaterialGroups,
        getMaterials,
        getSuppliers,
        getUsers,
        getAccessByModelId,
        getAccessByUserId,
        getPartners,
        getCountries,
        getCountryByName,
        getUsedSuppliersInScans,
        getTrendMaterials,
        getTrendLots,
        getTrendSuppliers,
        getSupportedAccessories,
        getMaterialsMeasurements,
        getUsedParametersForScans,
        getMaterialsScans,
        getScanners,
        getBiasCorrections,
        getScannerTypes,
        getTags,
        getCurrencies,
        getAcceptedProducts,
        getStoreAccesses,
        getRecoveryQuestions,
        getInferiorUsers,
        getUserOrganizations,
        getSubscribedProductsDetails,
        getDeployedMaterialParameters,
        getSubscriptionAccess,
        getModelParametersByModelId,
        getUnits,
        getLinkedUnitConversions,
        getAllowedUnitConversions,
        getModelParameterUnits,
        getSuperiorUsers,
        getClassifiers,
        getModelParameterProductVersionAvailableUnits,
        getCouponAcceptedProducts,
        getLots,
        getSimplifiedModel,
        getSupervisedUsers,
        getUsedMaterialsInScans,
        getUsedModelsInScans,
        getUsedLotsInScans,
        getModelParameterNamesByMaterial,
    };
}

export default LookupsAPI();
